import { ColorPicker as ColorPickerAntd } from 'antd';
import './ColorPicker.scss';

const ColorPicker = props => {
  return (
    <ColorPickerAntd
      {...props}
      rootClassName="color-picker-custom"
      trigger="click"
    />
  );
};

export default ColorPicker;
